module.exports = __webpack_public_path__ + "img/icon4.f01a899b.png";